import React from 'react';

export function NotFoundPage(): JSX.Element {
	return <h1>404 - Page not found</h1>;
}
